import api from '../index'

export default {
  /**
   * 获取论坛专题信息
   */
  getTopicsInfo(params) {
    return api.get('/api/forum/web', params, {})
  },
}
